/**
 * Safely serializes a value to JSON for use in a <script> tag.
 *
 * Plain JSON.stringify output can contain sequences like `</script>` or `<!--`
 * which cause the HTML parser to close the script tag early, enabling XSS.
 * This function unicode-escapes `<`, `>`, and `&` so those sequences are
 * invisible to the HTML parser while remaining valid JSON that any JSON
 * parser decodes back to the original characters.
 */
const serializeJsonForScriptTag = (value: unknown): string =>
  JSON.stringify(value).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');

export default serializeJsonForScriptTag;
